import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const PackageContentStyle = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;

	.wrapper {
		width: 100%;

		${breakPoints({
			'768': `
				flex-direction: row;
			`,
		})}
	}

	img {
		aspect-ratio: 16 / 9;
		width: 100%;
		flex-shrink: 0;
		object-fit: cover;

		${breakPoints({
			'768': `
			width: 208px;
		`,
		})}
	}

	.image-not-available {
		aspect-ratio: 16 / 9;
		width: 100%;
		flex-shrink: 0;
		background-color: rgb(242 242 242 / var(--tw-bg-opacity, 1));

		${breakPoints({
			'768': `
			width: 208px;
		`,
		})}
	}

	button {
		align-self: flex-start;
		align-items: center;
	}
`;
